module.exports = __webpack_public_path__ + "img/Group 28416@2x.c989acd8.svg";